<template>
  <v-app>
    <AppLoader></AppLoader>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style src="./main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue